import React from 'react';
import styled from 'styled-components';
import Register from '../../components/Registeration/Register';

const LandingPageContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const LoginBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
`;

const LoginBox = styled.div`
  background: rgba(255, 255, 255, 0.8);
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 400px;
  max-width: 90%;
  @media (max-width: 480px) {
    padding: 20px;
  }
`;

const Title = styled.h2`
  font-size: 1.8rem;
  color: #FFFFFF;
  margin-bottom: 20px;
`;

const ActionsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

const CancelLink = styled.a`
  color: #195174;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const SubmitButton = styled.input`
  padding: 10px 20px;
  font-size: 1rem;
  color: white;
  background-color: #195174;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #2980b9;
  }
`;

const InfoText = styled.p`
  font-size: 0.9rem;
  color: #555;
  margin-top: 20px;
  text-align: center;

  a {
    color: #195174;
    text-decoration: underline;
    &:hover {
      color: #2980b9;
    }
  }
`;

const RegistrationPage = ({ colors }) => {
  return (
    <LandingPageContainer>
      <LoginBoxContainer>
          <Title>Create An Account</Title>
        <Register colors={colors} />
      </LoginBoxContainer>
    </LandingPageContainer>
  );
};

export default RegistrationPage;
